import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Loader from '@site/component-loader';
import { getBaseApiUrl } from '../utils';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
var namespace = 'pxNotifications';
var defaultEntryKey = 'notifications';
var Notifications = function Notifications(props) {
  var baseUrl = getBaseApiUrl();
  var entryKey = props.entryKey || defaultEntryKey;
  var handleLoad = function handleLoad() {
    try {
      window[namespace][entryKey].loadNotifications(props.id, _objectSpread({}, props));
    } catch (_unused) {/* do nothing */}
  };
  useEffect(function () {
    var _window$namespace, _window$namespace$ent;
    if ((_window$namespace = window[namespace]) !== null && _window$namespace !== void 0 && (_window$namespace$ent = _window$namespace[entryKey]) !== null && _window$namespace$ent !== void 0 && _window$namespace$ent.loadNotifications) {
      handleLoad();
    }
  }, []);
  var assetsUrl = "".concat(baseUrl, "/v1/assets/px-assets-notifications");
  if (props.bucket) {
    assetsUrl = "".concat(assetsUrl, "/").concat(props.bucket);
  }
  assetsUrl = "".concat(assetsUrl).concat(window.location.search);
  return /*#__PURE__*/React.createElement(Loader, _extends({}, props, {
    url: assetsUrl,
    entryKey: entryKey,
    nameSpace: namespace,
    replaceSrcMethodName: "getClientFiles",
    onLoad: handleLoad,
    loadingSpinner: /*#__PURE__*/React.createElement("div", null)
  }));
};
Notifications.propTypes = {
  appKey: PropTypes.string.isRequired,
  bucket: PropTypes.string,
  entryKey: PropTypes.string,
  id: PropTypes.string
};
export default Notifications;
//# sourceMappingURL=Notifications.js.map